import { useQuery } from 'react-query';
import corporateClientPlaceholders from 'services/api/corporateClientPlaceholders';
import notify from 'utils/notificationUtils';
import useTranslation from 'utils/hooks/useTranslation';

export const useGetCorporateClientPlaceholder = userAccountId => {
  const { translateText } = useTranslation();

  const getPlaceholderDetails = async () => {
    const result = await corporateClientPlaceholders.readByUserAccountId(userAccountId);

    return result?.data;
  };

  return useQuery({
    queryKey: [{ userAccountId }],
    queryFn: getPlaceholderDetails,
    enabled: !!userAccountId,
    retry: false,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    onError: () => {
      notify({
        type: 'error',
        title: translateText('corporateAccounts.corporateClient.register.internalError.title'),
        message: translateText('corporateAccounts.corporateClient.register.internalError.message'),
      });
    },
  });
};
